import classes from './AppletCarouselItem.module.css';

const AppletCarouselItem = ({ item, onSelect }) => {

  return (
    <div className={classes.Wrap}>
      {item.name || item.description ?
        <div className={classes.TooltipFrame} role="tooltip">
          <div className={classes.Tooltip}>
            <p className={classes.TooltipText}>
              {item.name &&
                <span className={classes.TooltipName}>
                  {item.name}
                </span>
              }
              {item.description &&
                <span className={classes.TooltipDescription}>
                  {item.description}
                </span>
              }
            </p>
          </div>
          <span className={classes.TooltipArrow} />
        </div>
        : null}
      <button type="button" className={classes.Item} onClick={onSelect} aria-label={item.name}>
        <span className={classes.IconHit}>
          <img src={item.iconUrl} className={classes.Icon} />
        </span>
      </button>
    </div>
  );
};

export default AppletCarouselItem;